import { FC, ReactNode } from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";

export const NewsletterFormSignUpLayout: FC<{
  backgroundColor: string;
  slots: {
    title: ReactNode;
    fields: ReactNode;
    submitButton: ReactNode;
  };
  isEmbedded?: boolean;
}> = ({ backgroundColor, slots, isEmbedded }) => {
  return (
    <Stack
      sx={{
        backgroundColor,
        display: "flex",
        padding: (theme) => ({ xs: theme.spacing(2), sm: theme.spacing(3) }),
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: (theme) => theme.radius(2),
        overflow: "hidden",
        maxWidth: isEmbedded
          ? "100%"
          : {
              xs: "100%",
              sm: "434px",
            },
      }}
      gap={{ xs: 1, sm: 2 }}
    >
      <Box
        width="100%"
        textAlign="left"
        overflow="hidden"
        sx={{
          wordBreak: "break-word",
        }}
      >
        {slots.title}
      </Box>
      <Box width="100%">{slots.fields}</Box>
      <Box marginTop={1} width="100%">
        {slots.submitButton}
      </Box>
    </Stack>
  );
};
